import React, { Component } from 'react';
import icons from '../email/icons'
const ENV =
    process.env.NODE_ENV === 'production'
        ? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
        : `http://${window.location.hostname}:5015/`;
class IconChooserBox extends Component {
    render() {
        const {
            label,
            errorTrigger,
            errorMessage,
            value,
            style,
            required,
            classes,
            onClick,
        } = this.props;
        return (
            <div key={label} className={`formFieldContainer color ${classes ? classes : ''}  ${errorTrigger ? 'error' : ''}`} style={style}>
                <div className="formField">
                    <div className="labelContainer">
                        <div className="formFieldLabel">
                            {label}
                            {required ? '*' : ''}
                        </div>
                        {errorTrigger && <div className="formFieldLabel error">{errorMessage || 'Required'} </div>}
                    </div>
                    <div className={``}>

                        <div style={{ minWidth: 200, maxHeight: 300, overflowX: 'hidden', display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                            {icons.map((i, index) => {
                                return <img src={`${ENV}API/icons/svg/${i.value}/${value === i.value ? 'blue' : 'black'}`} style={{ cursor: 'pointer', width: 30, height: 30 }} key={`icon-${index}`} onClick={() => {
                                    onClick(i.value)
                                }} alt="icon"
                                    title={i.value}
                                />
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IconChooserBox;
